import { ClipboardList } from 'lucide-react';
import { nomePessoa } from '../../nucleo/formato';
import { caminhoDaAba, type FonteBuscaGlobal } from '../../nucleo/modulos-web';
import { discretoAtivo } from '../../nucleo/discreto';

/**
 * Review rl30-1 (spec B2, lista de 30/10 item 10): pedidos de ausência (nome do funcionário ou do tipo, a busca da aba). A
 * página Pedidos lê `?busca=`; o item abre a lista filtrada pelo nome do funcionário.
 */
interface PedidoBusca {
  id: string;
  funcionario_nome: string | null;
  tipo_nome: string;
  inicio: string;
  fim: string;
}

const lista = (busca: string) => (busca ? `${caminhoDaAba('ausencias', 'pedidos')}?busca=${encodeURIComponent(busca)}` : `${caminhoDaAba('ausencias', 'pedidos')}`);

// Rodada rl30-2 (VIS-M2): com o modo discreto, o item não leva o texto do registro para a busca da lista (ficaria por extenso no
// campo e no endereço); a lista abre sem filtro. O "Ver todos" segue com o termo que a própria pessoa digitou.
export const buscaAusencias: FonteBuscaGlobal[] = [
  {
    chave: 'pedidos',
    permissao: 'ausencias.ver',
    pagina: 'ausencias.pedidos',
    grupo: 'buscaGlobal.pedidos',
    posicao: 62,
    icone: ClipboardList,
    item: (p: PedidoBusca) => ({
      id: p.id,
      rotulo: nomePessoa(p.funcionario_nome ?? '') || p.tipo_nome,
      detalhe: p.tipo_nome,
      link: discretoAtivo() ? lista('') : lista(p.funcionario_nome ?? p.tipo_nome),
    }),
    verTodos: lista,
  },
];
